import React, { useMemo } from 'react'
import { usePageLayout } from '../hooks/usePageLayout'

function About() {
  // Memoize layout options to prevent infinite re-renders
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      title: {
        en: 'About',
        zh_cn: '关于我们',
        zh_hk: '關於我們',
      },
    }),
    [],
  )

  // About page should show all navigation elements
  usePageLayout(layoutOptions)

  return (
    <>
      <h1 className="mt-40 ml-44 text-4xl font-extrabold">
        About Feelings AI Group
      </h1>
    </>
  )
}

export default About
